import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDogearCards = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 34,
	viewBox: "0 0 26 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_14342_79575)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M5 1.5C5 1.22386 5.22386 1 5.5 1H20.5C20.7761 1 21 1.22386 21 1.5V24.191C21 24.5627 20.6088 24.8044 20.2764 24.6382L13.2236 21.1118C13.0828 21.0414 12.9172 21.0414 12.7764 21.1118L5.72361 24.6382C5.39116 24.8044 5 24.5627 5 24.191V1.5Z",
				fill: "#3495F0"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M5.5 0.75C5.08579 0.75 4.75 1.08579 4.75 1.5V24.191C4.75 24.7485 5.33673 25.1111 5.83541 24.8618L12.8882 21.3354C12.9586 21.3002 13.0414 21.3002 13.1118 21.3354L20.1646 24.8618C20.6633 25.1111 21.25 24.7485 21.25 24.191V1.5C21.25 1.08579 20.9142 0.75 20.5 0.75H5.5Z",
				stroke: "white",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.8257,
			y: 6.58301,
			width: 7.25758,
			height: 7.50419,
			fill: "#3495F0",
			stroke: "white",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.37122,
			y: 7.91504,
			width: 7.25758,
			height: 7.50419,
			fill: "#3495F0",
			stroke: "white",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.91663,
			y: 9.24512,
			width: 7.25758,
			height: 7.50419,
			fill: "#3495F0",
			stroke: "white",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_14342_79575",
			x: .5,
			y: .5,
			width: 25,
			height: 32.6924,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "multiply",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_14342_79575"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_14342_79575",
					result: "effect2_dropShadow_14342_79575"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_14342_79575",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgDogearCards;
